var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.themeCfg,{tag:"component",attrs:{"query-cfg":_vm.queryCfg}})
}
var staticRenderFns = []

export { render, staticRenderFns }